export default __webpack_public_path__ + "media/images/avis_neutre-3a42901fe3491defb87458e63916a573.png";